"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Kentaro Kawakatsu
 */
var UniformObject = /** @class */ (function () {
    function UniformObject($type, $name) {
        this.name = $name;
        this.type = $type;
    }
    UniformObject.TYPE_VALUE = 0;
    UniformObject.TYPE_VECTOR3 = 1;
    UniformObject.TYPE_VECTOR4 = 2;
    UniformObject.TYPE_MATRIX = 3;
    UniformObject.TYPE_TEXTURE = 4;
    return UniformObject;
}());
exports.UniformObject = UniformObject;



//////////////////
// WEBPACK FOOTER
// ./src/ts/myLib/webgl/engine/UniformObject.ts
// module id = 5
// module chunks = 0